import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useTabBar } from "@website/ui/tab-bar/tab-bar.hook";
import styles from "@website/ui/tab-bar/tab-bar.module.scss";
import { TabBarPropertiesType } from "@website/ui/tab-bar/tab-bar.types";
import { TabButton } from "@website/ui/tab-button";
import { FC } from "react";
export const TabBar: FC<TabBarPropertiesType> = properties => {
  const $ = _c(32);
  const {
    "aria-label": ariaLabel,
    className,
    color: t0,
    variant: t1,
    iconPosition: t2,
    orientation: t3,
    behavior: t4,
    size: t5,
    transparent: t6,
    buttonGap: t7,
    buttonContentMinWidth: t8,
    tabs,
    value
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const variant = t1 === undefined ? "contained" : t1;
  const iconPosition = t2 === undefined ? "top" : t2;
  const orientation = t3 === undefined ? "horizontal" : t3;
  const behavior = t4 === undefined ? "button" : t4;
  const size = t5 === undefined ? "content" : t5;
  const transparent = t6 === undefined ? false : t6;
  const buttonGap = t7 === undefined ? false : t7;
  const buttonContentMinWidth = t8 === undefined ? true : t8;
  const {
    buttonsContainerProps,
    nextScrollProps,
    previousScrollProps
  } = useTabBar(properties);
  const t9 = `${styles["tab-bar"]} ${styles[orientation]} ${styles[color]} ${styles[variant]} ${transparent ? styles.transparent : ""} ${buttonGap ? styles["button-gap"] : ""} ${className ?? ""}`;
  let t10;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MaterialIcon className={styles["nav-button-icon"]} name="arrow_back_ios" variant="outlined" />;
    $[0] = t10;
  } else {
    t10 = $[0];
  }
  let t11;
  if ($[1] !== previousScrollProps) {
    t11 = <div {...previousScrollProps} className={styles["nav-button"]}>{t10}</div>;
    $[1] = previousScrollProps;
    $[2] = t11;
  } else {
    t11 = $[2];
  }
  let t12;
  if ($[3] !== behavior || $[4] !== buttonContentMinWidth || $[5] !== color || $[6] !== iconPosition || $[7] !== size || $[8] !== tabs || $[9] !== value || $[10] !== variant) {
    let t13;
    if ($[12] !== behavior || $[13] !== buttonContentMinWidth || $[14] !== color || $[15] !== iconPosition || $[16] !== size || $[17] !== value || $[18] !== variant) {
      t13 = (item, index) => <TabButton Icon={item.Icon} Wrapper={item.Wrapper} badge={item.badge} behavior={behavior} color={color} description={item.description} disabled={item.disabled} href={item.href} iconPosition={iconPosition} index={index} key={item.title} onClick={item.onClick} selected={value === index} size={size} title={item.title} variant={variant} contentMinWidth={buttonContentMinWidth} />;
      $[12] = behavior;
      $[13] = buttonContentMinWidth;
      $[14] = color;
      $[15] = iconPosition;
      $[16] = size;
      $[17] = value;
      $[18] = variant;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    t12 = tabs.map(t13);
    $[3] = behavior;
    $[4] = buttonContentMinWidth;
    $[5] = color;
    $[6] = iconPosition;
    $[7] = size;
    $[8] = tabs;
    $[9] = value;
    $[10] = variant;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[20] !== ariaLabel || $[21] !== buttonsContainerProps || $[22] !== t12) {
    t13 = <div {...buttonsContainerProps} aria-label={ariaLabel} className={styles["buttons-container"]} role="tablist">{t12}</div>;
    $[20] = ariaLabel;
    $[21] = buttonsContainerProps;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <MaterialIcon className={styles["nav-button-icon"]} name="arrow_forward_ios" variant="outlined" />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== nextScrollProps) {
    t15 = <div {...nextScrollProps} className={styles["nav-button"]}>{t14}</div>;
    $[25] = nextScrollProps;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t11 || $[28] !== t13 || $[29] !== t15 || $[30] !== t9) {
    t16 = <div className={t9}>{t11}{t13}{t15}</div>;
    $[27] = t11;
    $[28] = t13;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};